import React from 'react';
const IconMiscPinFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C7.59 2 4 5.59 4 10C4 14.55 7.28 17.72 12 21.83C16.8 17.65 20 14.53 20 10C20 5.59 16.41 2 12 2ZM12 12.5C10.62 12.5 9.5 11.38 9.5 10C9.5 8.62 10.62 7.5 12 7.5C13.38 7.5 14.5 8.62 14.5 10C14.5 11.38 13.38 12.5 12 12.5Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscPinFill;